import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Modal, Button, Form, Table } from 'react-bootstrap';

import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { DOWNLOADULD } from '../../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Radown from "../../../../../assets/images/radown.png";
import Trash from "../../../../../assets/images/trash.png";
import Export from "../../../../../assets/images/export.svg";
import Bin from "../../../../../assets/images/bin.png";
import { saveAs } from "file-saver"; 

const GalleryView = ({ attachments, onClose }) => {

    const [files, setFiles] = useState([]);
    const [galleryViewOpen, setGalleryViewOpen] = useState(true);

    const [selectedFile, setSelectedFile] = useState('');
    const [imgShow, setImgShow] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedDelFile, setSelectedDelFile] = useState({
        index: null,
        id: null,
    });

    const [isMulti, setIsMulti] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    useEffect(() => {
        if (attachments) {
            setFiles(attachments);
        }
    }, [attachments]);

    const galleryViewclose = () => {
        setGalleryViewOpen(false);
        onClose();
    };

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setSelectedFile('');
    };

    const handleDeleteImageTop = () => {
        if (selectedRows.length > 0) {
            setShowConfirmation(true);
            setIsTopDel(true);
        } else {
            toast.error("Please select at least one image");
        }
    };

    const closeConfirm = () => {
        setShowConfirmation(false);
        setSelectedDelFile({ index: null, id: null });
        setIsTopDel(false);
        setIsMulti(false);
    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            // handleDeleteFile(
            //     selectedDelFile.index,
            //     selectedDelFile.id,
            //     selectedDelFile.type
            // );
            setShowConfirmation(false);
        } else {
            closeConfirm();
        }
    };

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const multipleDownload = async () => {
        let payload = {};
        // if (attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld') {
        //     payload = {
        //         uld_number: attachment_no,
        //         attachments: selectedRows
        //     }
        // } else if (attachable_type == 'service_recovery' || attachable_type == 'service_recovery_handler_feedback') {
        //     payload = {
        //         service_recovery_id: attachable_id,
        //         attachments: selectedRows
        //     }
        // } else {
        //     payload = {
        //         uld_number: attachable_id,
        //         attachments: selectedRows
        //     }
        // }
        // const res = await withRFSToken.post(DOWNLOADFILES, payload) // { uld_number: attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld' ? attachment_no : attachable_id, attachments: selectedRows, }
        //     .then(function (res) {
        //         if (res.data.response_code == 200) {
        //             const downloadUrl = res.data.response_data;
        //             const a = document.createElement("a");
        //             a.href = downloadUrl;
        //             a.download = "download.zip"; // You can set a default filename here
        //             document.body.appendChild(a);
        //             a.click();
        //             document.body.removeChild(a);
        //             toast.success("Downloaded Successfully");
        //         } else {
        //             toast.error(res.data.response_msg);
        //         }
        //     });
    };

    return (
        <>
            <Modal show={imgShow} onHide={handleClose} centered className="imgmodal">
                <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                <Modal.Body>
                    {/* {console.log(selectedFile)} */}
                    <img src={selectedFile} className="img-fluid" alt="Selected" />
                </Modal.Body>
            </Modal>
            <Modal show={galleryViewOpen} onHide={galleryViewclose} className="addfrom change_type" centered size="xl">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between">
                        <div className="attchment">
                            <h3>
                                Shipment Attachments
                                <span>
                                    Attachments
                                    <span className="rabadge badge bg-primary">
                                        {attachments?.length}
                                    </span>
                                </span>
                            </h3>
                        </div>

                        <div className="gallery_download">
                            <button onClick={handleDeleteImageTop}>
                                <img title="" src={Trash} /> <span>Delete</span>
                            </button>
                            <button onClick={multipleDownload}>
                                <img src={Export} /> <span>Download</span>
                            </button>
                        </div>
                    </div>

                    <div className="my-3">
                        <Table className="gallery_view">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Document Type</th>
                                    <th>Size</th>
                                    <th>Date added</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {files.map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();

                                    return (
                                        <tr key={`gv${index}`}>
                                            <td>
                                                {/* {console.log('attachment_no', file)} */}
                                                <Form.Check // prettier-ignore
                                                    type="checkbox"
                                                    id="checkbox"
                                                    checked={selectedRows.some(
                                                        (row) => row.attachment_id === file.id
                                                    )}
                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                />
                                            </td>
                                            <td className="delimg">
                                                <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                            </td>
                                            <td>
                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                ) ? (
                                                    <>
                                                        <img
                                                            src={file.file_path}
                                                            alt="Preview"
                                                            style={{
                                                                maxWidth: "22px",
                                                                maxHeight: "22px",
                                                                marginRight: "10px",
                                                            }}
                                                            onClick={() => handleFileClick(file.file_path)}
                                                        />
                                                        <span>
                                                            {/*file.file_name*/}
                                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* <span className="d-flex rafilename">
                                                            <img src={Docmnt} className="fileimg" />
                                                            <span>{file.file_name}</span>
                                                        </span> */}
                                                    </>
                                                )}
                                                {/* <img src={Galpic} className='fileimg' /> {file.file_name} */}
                                            </td>
                                            <td>{file.file_type}</td>
                                            <td>{file.file_size}</td>
                                            <td>{file.upload_time}</td>
                                            <td className="delimg">
                                                {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                                <img src={Bin} />  {/* onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} */}
                                                {/* )} */}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
        </>
    )
}

export default GalleryView